import Box from '@mui/material/Box'
import addBoxy from '../../svg/boxyIcons/addBoxy.svg'
import AddIcon from '@mui/icons-material/Add';

const Add = () => {
    const iconSelect = localStorage.getItem('iconsSelect')
    const icon = iconSelect === 'Boxy'
        ? <img src={addBoxy} alt='Add' />
        : <AddIcon />

    return (
        <Box
            sx={{
                display: 'flex',
                height: 25,
                width: 25,
                '& img': { height: 25, width: 25 }
            }}
        >
            {icon}
        </Box>
    )
}

export default Add
